<style scoped>
    @import "./index.css";
</style>

<template>
    <div id="login">
        <div class="login-header"></div>
        <div class="login-content-wrap">
          <div class="login-content">
              <Row type="flex" justify="center">
                  <Col :xs="24">
                      <div class="header-logo">
                          <h3>瀚土智能管理系统</h3>
                      </div>
                      <Alert show-icon>欢迎使用瀚土智能管理系统</Alert>
                      <Form ref="accountLogin" :model="accountLogin" :rules="accountLoginRule">
                          <FormItem prop="phone">
                              <Input placeholder="请输入手机号" :maxlength="11" icon="ios-person" clearable size="large" type="text" v-model="accountLogin.phone"></Input>
                          </FormItem>
                          <FormItem prop="password">
                              <Input placeholder="请输入密码" icon="ios-unlock" clearable size="large" type="password" v-model="accountLogin.password"></Input>
                          </FormItem>
                          <FormItem prop="check" style="margin-bottom:0">
                            <div class="jizhu-password f12">
                              <div><Checkbox label="Eat" v-model="accountLogin.check"></Checkbox> 7日免输密码</div>
                              <a href="javascript:;" @click="$func.jumps('forgetpassword')">忘记密码</a>
                            </div>
                          </FormItem>
                          <FormItem class="mb5">
                              <Button long size="large" :loading="accountLogin.btnLoading" type="primary" @click="handleSubmit('accountLogin')">
                                  <span>{{!accountLogin.btnLoading ? '登录' : '登录中...'}}</span>
                              </Button>
                          </FormItem>
                          <FormItem>
                              <div class="tf-text-right">
                                  还没有账户? <a href="javascript:;" @click="$func.jumps('regist')">立即注册</a>
                              </div>
                          </FormItem>
                      </Form>
                      <!--<Divider style="font-size:12px; font-weight: normal">第三方登录</Divider>-->
                      <!--<Row type="flex" justify="space-around" style="margin-bottom: 15px">-->
                          <!--<Col style="cursor:pointer;text-align: center; line-height: 180%">-->
                              <!--<div @click="qqLogin">-->
                                <!--<Avatar :src="qq" /><br/>QQ登录-->
                              <!--</div>-->
                          <!--</Col>-->
                          <!--<Col style="cursor:pointer;text-align: center; line-height: 180%">-->
                              <!--<div @click="wxLogin">-->
                                  <!--<Avatar :src="wx" /><br/>微信登录-->
                              <!--</div>-->
                          <!--</Col>-->
                          <!--<Col style="cursor:pointer;text-align: center; line-height: 180%">-->
                              <!--<div @click="wbLogin">-->
                                  <!--<Avatar :src="wb" /><br/>微博登录-->
                              <!--</div>-->
                          <!--</Col>-->
                      <!--</Row>-->
                  </Col>
              </Row>
          </div>
        </div>
        <div class="login-footer">
            © 1999-2019 瀚土智能 All rights reserved.
        </div>
    </div>
</template>

<script>
import qq from '@/assets/img/qq.png';
import wx from '@/assets/img/wx.png';
import wb from '@/assets/img/wb.png';

export default {
  name: "login",
  beforeCreate() {
    //设置背景色
    document.querySelector("body").setAttribute("style", "background:#fbfbfb");
  },
  beforeDestroy() {
    //去除背景色
    document.querySelector("body").setAttribute("style", "");
  },
  created() {
    const that = this;
    //获取cookie数据
    that.accountLogin.phone = that.$func.data.get("phone");
    that.accountLogin.password = that.$func.data.get("password");
  },
  data() {
    return {
        // +---------------
        // | 第三方登录图片
        // +---------------
        qq:qq,
        wx:wx,
        wb:wb,

      // +---------------
      // | 输入框数据
      // +---------------
      accountLogin: {
        phone: "",
        password: "",
        check: false,
        btnLoading: false
      },

      // +---------------
      // | 验证规则
      // +---------------
      accountLoginRule: {
        //账号登录
        phone: [
          {required: true, message: "请输入手机号", trigger: "blur" },
          {pattern: /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[1-9])[0-9]{8}$/, message: "请输入正确的手机号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请设置密码", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    qqLogin(){
        let that = this;
        that.$func.msg('授权成功');
        that.$func.dsqOut(function(){
            that.$router.push({name:'bindphone',params: {type:1}})
        },2)
    },
    wxLogin(){
        let that = this;
        that.$func.msg('授权成功');
        that.$func.dsqOut(function(){
            that.$router.push({name:'bindphone',params: {type:2}})
        },2)
    },
    wbLogin(){
        let that = this;
        that.$func.msg('授权成功');
        that.$func.dsqOut(function(){
            that.$router.push({name:'bindphone',params: {type:3}})
        },2)
    },
    // +---------------
    // | 提交表单
    // +---------------
    handleSubmit(name) {
      const that = this;
      //验证表单
      that.$refs[name].validate(valid => {
        if (valid)
        {
            //按钮状态关闭
            that[name].btnLoading = false;

            //判断是否保存密码
            if (that.accountLogin.check) {
                that.$func.data.set(
                    "phone",
                    that.accountLogin.phone,
                    "cookie",
                    { expires: 7 }
                );
                that.$func.data.set(
                    "password",
                    that.accountLogin.password,
                    "cookie",
                    { expires: 7 }
                );
            }

            //登录
            that.$func.ajax('doLoginPwd',
            {
                phone : that.accountLogin.phone,
                loginPwd : that.accountLogin.password
            },function(r){
                if(!r.statusCode){
                    that.$func.msg(r.message,'error');
                }else{
                    that.$func.msg('登录成功')
                    //存储登录数据
                    that.$func.data.set("userInfo", r.type);
                    that.$refs[name].resetFields();
                    //获取需要养护的
                    that.getMaintainNotice();

                }
            })
        }
      });
    },
      //获取需要养护的
      getMaintainNotice(){
          let that = this;
          that.$func.ajax('maintainNotice',{
          },function (r) {
              if(!r.statusCode){
                  that.$func.msg(r.message,'error');
              }else{
                  if(r.type.length>0){

                      //跳转到养护
                      that.$func.dsqOut(function() {
                          that.$router.push({
                              name: "maintain"
                          });
                          that.$Modal.confirm({
                              title: '有养护过期，请及时养护',
                           })
                      },1.5);
                  }else {
                      //跳转控制台
                      that.$func.dsqOut(function() {
                          that.$router.push({
                              name: "index"
                          });
                      },1.5);
                  }
              }
          })
      },
  }
};
</script>
